import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import LinkButton from "../../../components/link-button/link-button";
import { routeMapping } from "../../../route.config";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const OtherFeatures = ({ className }: IWithClassName) => (
    <div className={className}>
        <h2 className="secondary-features-list-title">OTHER FEATURES</h2>
        <div>
            <Button
                LinkComponent={LinkButton}
                className="secondary-features-list-item"
                variant="contained"
                color="secondary"
                href={routeMapping.trackedLists.path}
            >
                Tracked List
                <img
                    src="/assets/rightarrow.png"
                    className="right-arrow-icon"
                    alt="tracked-list-right-icon"
                />
            </Button>
            <Button
                LinkComponent={LinkButton}
                className="secondary-features-list-item"
                variant="contained"
                color="secondary"
                href={routeMapping.changeLog.path}
            >
                Change Log
                <img
                    src="/assets/rightarrow.png"
                    className="right-arrow-icon"
                    alt="change-log-right-icon"
                />
            </Button>
            <Button
                LinkComponent={LinkButton}
                className="secondary-features-list-item"
                variant="contained"
                color="secondary"
                href={routeMapping.faq.path}
            >
                FAQ
                <img
                    src="/assets/rightarrow.png"
                    className="right-arrow-icon"
                    alt="faq-right-icon"
                />
            </Button>
        </div>
    </div>
);

export default styled(OtherFeatures)(({ theme }: IWithThemeProps) => ({
    flexGrow: 0,
    flexBasis: theme?.spacing(64),
    flexShrink: 0,

    ".secondary-features-list-title": {
        fontWeight: 600,
        fontSize: 20,
        marginTop: theme?.spacing(6),
        marginBottom: theme?.spacing(2.5),
        color: theme?.palette.otherFeatures.titleColor,
    },
    ".secondary-features-list-item": {
        display: "flex",
        justifyContent: "space-between",
        height: 76,
        marginTop: theme?.spacing(2.5),
        marginBottom: theme?.spacing(2.5),
        borderRadius: theme?.spacing(2.5),
        paddingLeft: theme?.spacing(4.5),
        fontSize: 28,
        backgroundColor: theme?.palette.otherFeatures.bgColor,
        color: theme?.palette.otherFeatures.textColor,
        textTransform: "none",
    },
    ".right-arrow-icon": {
        paddingRight: 24,
        height: 34,
        width: 38,
    },
}));
